import { Box, Typography, Button } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import AssignmentIcon from '@mui/icons-material/Assignment';
import HeadphonesIcon from '@mui/icons-material/Headphones';
import GradingIcon from '@mui/icons-material/Grading';
import { usePatient } from '../context/patientContext';
import "../styles/testFlow.css";
import { useTranslation } from 'react-i18next';


function Testflow() {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const { getPatientName } = usePatient();
  const patientFullName = getPatientName();

  // Get step from state or previous page, default 'questionnaire'
  const step = location.state?.step ?? (
    (location.state?.from === '/signup' || location.state?.from === '/questionnaire') ? 'questionnaire'
      : (location.state?.from === 'assignTest') ? 'test'
        : 'questionnaire'
  );

  const back =
    step === 'questionnaire'
      ? { text: t('common.back'), to: '/signup' }
      : step === 'test'
        ? { text: t('common.back'), to: '/questionnaire' }
        // When navigating back from the results page, we want to go directly to the assign test page.
        : { text: t('common.back'), to: '/assignTest' };

  const next =
    step === 'questionnaire'
      ? { text: t('testflow.startQuestionnaire'), to: '/questionnaire' }
      : step === 'test'
        ? { text: t('testflow.startHearingTest'), to: '/assignTest' }
        : { text: t('testflow.viewResults'), to: '/results' };

  const isActive = (key) => key === step;

  return (
    <Box className="testflow">
      <Typography component="h1" variant="h5" align="center" className="testflow__title">
        {t('testflow.hello', { name: patientFullName ?? t('testflow.patient') })}
      </Typography>

      <Box className="testflow__steps">
        <Box className={`testflow__step ${isActive('questionnaire') ? 'is-active' : 'is-inactive'}`}>
          <AssignmentIcon fontSize="large" color={isActive('questionnaire') ? 'primary' : 'inherit'} />
          {t('testflow.questionnaire')}
        </Box>

        <Box className={`testflow__step ${isActive('test') ? 'is-active' : 'is-inactive'}`}>
          <HeadphonesIcon fontSize="large" color={isActive('test') ? 'primary' : 'inherit'} />
          {t('testflow.test')}
        </Box>

        <Box className={`testflow__step ${isActive('result') ? 'is-active' : 'is-inactive'}`}>
          <GradingIcon fontSize="large" color={isActive('result') ? 'primary' : 'inherit'} />
          {t('testflow.results')}
        </Box>
      </Box>

      <Box component="form" className="testflow__form">
        <Button
          data-cy="test_flow_back_btn"
          onClick={() => navigate(back.to, { state: { ...(location.state || {}), from: location.pathname } })}
          type="button"
          fullWidth
          variant="contained"
          color="primary"
          className="testflow__button"
        >
          {back.text}
        </Button>
        <Button
          data-cy="test_flow_btn"
          onClick={() => navigate(next.to, { state: { ...(location.state || {}), from: location.pathname } })}
          type="button"
          fullWidth
          variant="contained"
          color="primary"
          className="testflow__button testflow__button--next"
        >
          {next.text}
        </Button>
      </Box>
    </Box>
  );
}

export default Testflow;
